module.exports = __webpack_public_path__ + "img/37.92ec5aa8.jpg";